import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import { Popover } from '@creditornot/cb-popover';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import { useListingManagerLastEdited } from './useListingManagerLastEdited';

const LastEditedPopoverRoot = styled.div`
  margin-block-start: auto;
`;

const MenuLastEdited = styled.div`
  ${typographyCss.Small()};
  color: ${cbSemanticCssVars.textSecondary};
  margin-block: 40px;
  cursor: pointer;
  max-width: 300px;
`;

const LastEditedInfoRoot = styled.div`
  ${typographyCss.Small()};
  padding: 18px;
`;

const Title = styled(T.Small)`
  display: block;
  margin-block-end: 16px;
  color: ${cbSemanticCssVars.textSecondary};
`;

const Rows = styled.div``;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 28px;
`;

type Author = {
  name: string | null;
  date: string;
  time: string;
};

type LastEditedInfoProps = {
  lastFiveEdits: Author[];
};

const LastEditedInfo = ({ lastFiveEdits }: LastEditedInfoProps) => {
  return (
    <LastEditedInfoRoot>
      <Title>
        <FormattedMessage id="listing-manager.selections.editor.navigation.last-five-edits" />
      </Title>
      <Rows>
        {lastFiveEdits.map((author, index) => (
          <Row key={index}>
            <T.Small>
              {author.date} at {author.time}
            </T.Small>
            {author.name && <T.Small>{author.name}</T.Small>}
          </Row>
        ))}
      </Rows>
    </LastEditedInfoRoot>
  );
};

export const LastEditedPopover = () => {
  const { allAuthors } = useListingManagerLastEdited();
  const date = allAuthors && allAuthors?.length > 0 ? allAuthors[0].date : '';
  const time = allAuthors && allAuthors?.length > 0 ? allAuthors[0].time : '';
  const author = allAuthors && allAuthors?.length > 0 ? allAuthors[0].name : null;

  const editedId =
    allAuthors && allAuthors[0]?.name
      ? 'listing-manager.selections.editor.navigation.last-edited-by'
      : 'listing-manager.selections.editor.navigation.last-edited-by-short';

  if (allAuthors && allAuthors.length > 0) {
    return (
      <LastEditedPopoverRoot>
        <Popover
          placement="top"
          openOnHover={allAuthors.length > 1}
          openOnClick={false}
          content={<LastEditedInfo lastFiveEdits={allAuthors} />}
        >
          {({ refProps }) => (
            <MenuLastEdited {...refProps}>
              <FormattedMessage
                id={editedId}
                values={
                  editedId === 'listing-manager.selections.editor.navigation.last-edited-by-short'
                    ? { time, date, bold: chunks => <b>{chunks}</b> }
                    : { time, date, author, bold: chunks => <b>{chunks}</b> }
                }
              />
            </MenuLastEdited>
          )}
        </Popover>
      </LastEditedPopoverRoot>
    );
  }
  return null;
};
